<template>
  <div>
    <button type="button" class="btn btn-sm btn-red" title="Delete" @click="askToConfirm">
      <i class="fa fa-trash"></i>
    </button>
    <b-modal v-model="dialog" width="500" hide-footer hide-header>
      <b-card>
        <form method="post" :action="action" ref="deleteForm">
          <input type="hidden" name="_token" :value="csrf" />
          <b-card-title class="headline grey lighten-2"> Before you delete this user </b-card-title>

          <b-card-text> Please select a user who will inherit all the projects, etc. </b-card-text>

          <b-row>
            <b-col class="d-flex" cols="12">
              <b-select label="Please select user" v-model="userID" name="inherit_user">
                <b-form-select-option :value="item.id" v-for="item in users" :key="item.id"> {{ item.first_name }} {{ item.last_name }} </b-form-select-option>
              </b-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mt-2" cols="12">
              <button type="button" class="btn btn-danger float-end" :disabled="userID == null" @click="deleteUser">Delete User</button>
              <button type="button" class="btn btn-primary float-end me-1" @click="dialog = false">Cancel</button>
            </b-col>
          </b-row>
        </form>
      </b-card>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    action: {
      type: [String],
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userID: null,
      dialog: false,
      users: [],
      hasError: true,
    };
  },
  computed: {},
  methods: {
    askToConfirm() {
      const result = confirm("Are you sure to delete this record?");
      if (result) {
        this.toggleModal();
        this.getStaffUsers();
      }
    },
    toggleModal() {
      this.dialog = !this.dialog;
    },
    async getStaffUsers() {
      const url = `/admin/staff/api/index`;
      const response = await axios.get(url);
      this.users = response.data.users.filter(v => v.id != this.id);
    },
    deleteUser() {
      this.$refs.deleteForm.submit();
    },
  },
  //onclick="return confirm('Are you sure to delete this record?')"
};
</script>
